import { render, staticRenderFns } from "./AAsyncBtn.vue?vue&type=template&id=d61af654&scoped=true&"
import script from "./AAsyncBtn.vue?vue&type=script&lang=ts&"
export * from "./AAsyncBtn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d61af654",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
